const Kategoriya3411 = () => {
    return (
        <div style={{ fontFamily: "Times New Roman", fontSize: "14pt" }} className="container mt-5">
                <h3 className="text-center text-primary">
                    3-sinf 4-chorak<br />
                    Mavzu: Son, fe'l<br />
                    "Eng oson" bo'limidagi topshiriqlar va ularni o'tkazish metodikasi
                </h3>
                <b>1-mashq. Nuqtalar o'rniga sonlar bog'langan so'zni to'g'ri yozing.</b><br />
                <i>Ta'limiy maqsad:</i> O'quvchilarning lingvistik ko'nikmalarini rivojlantirish.<br />
                <i>Mashg'ulot davomiyligi:</i> 3-4 daqiqa<br />
                O'ninchi … (sinf, kitob, non) - _______________________________________<br />
                XX … (yil, oy, kun, asr) - _________________________________________
                <p><b>2-mashq. Nuqtalar o'rniga mos qo'shimcha qo'shing va so'z birikmalari tuzing.</b></p>
                <p><i>Ta'limiy maqsad:</i> O'quvchilarning lingvistik ko'nikmalarini rivojlantirish.</p>
                <p><i>Mashg'ulot davomiyligi:</i> 3-4 daqiqa</p>
                <p>Bir… o'quvchi</p>
                <p>Bolalar… katta…</p>
                <p>O'n… yarmi</p>
                <p>Yuz… bir…</p>
                <p>Opam… soyabon…</p>
                <p>Ko'klam… tarovat…</p>
                <p><b>3-mashq. Iboralarning ma'nosini izohlang va ular ishtirokida gap tuzing.</b></p>
                <p><i>Ta'limiy maqsad:</i> O'quvchilarning lingvistik ko'nikmalarini rivojlantirish.</p>
                <p><i>Mashg'ulot davomiyligi:</i> 3-4 daqiqa</p>
                <p>Dami ichida - _________________________________________________</p>
                <p>____________________________________________________________</p>
                <p>Dami chiqmoq - ________________________________________________</p>
                <p>______________________________________________________________</p>
        </div>
    )
}
export default Kategoriya3411;